// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autocomplete-text {
    background-color: #C0C0C0;
    color: #000080;
    font-weight: bold;
    padding: 2px 0;
    border-radius: 3px;
}  `, "",{"version":3,"sources":["webpack://./src/MyEditor/AutoComplete/AutocompleteSpan.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".autocomplete-text {\n    background-color: #C0C0C0;\n    color: #000080;\n    font-weight: bold;\n    padding: 2px 0;\n    border-radius: 3px;\n}  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
